import React from 'react';
import { protectedRoute } from '@/modules/core/root/protected/route';
import { RouteErrorHandler } from '@/shared/components/route-error-handler';
import { createRoute } from '@tanstack/react-router';

export const analyticsRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'analytics',
  component: React.lazy(async () => await import('@/app/routes/Analytics')),
  wrapInSuspense: true,
  errorComponent: ({ error, reset }) => {
    return <RouteErrorHandler error={error} reset={reset} routeName="analytics" />;
  },
});
